import React from 'react';
import s from './TransparentButton.scss';


const TransparentButton = ({ onClick, children, autoFocus, className = '', disabled = false, id, name, value }) => {

  return (
    <button onClick={onClick} value={value} disabled={disabled} name={name} autoFocus={autoFocus} className={s.transparentButton} id={id}>
        {children}
    </button>
  )
};

export default TransparentButton;
